import { createContext, useContext, useState, useEffect } from 'react';

const WishlistContext = createContext();

const getProductId = (product) => product?.id || product?.name;

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState(() => {
    const stored = localStorage.getItem('wishlist');
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem('wishlist', JSON.stringify(wishlistItems));
  }, [wishlistItems]);

  const addToWishlist = (product) => {
    const pid = getProductId(product);
    if (wishlistItems.some(i => getProductId(i) === pid)) return;
    setWishlistItems([...wishlistItems, product]);
  };

  const removeFromWishlist = (idOrProduct) => {
    const pid = typeof idOrProduct === 'number' || typeof idOrProduct === 'string' 
      ? idOrProduct 
      : getProductId(idOrProduct);
    setWishlistItems(prev => prev.filter(i => getProductId(i) !== pid));
  };

  const isWishlisted = (id) => {
    const pid = id || getProductId(id);
    return wishlistItems.some(i => getProductId(i) === pid);
  };

  return (
    <WishlistContext.Provider value={{ wishlistItems, addToWishlist, removeFromWishlist, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);